import UI from "~/ui";
import $ from "jquery";

/**
 * Gestisce il download di un documento associato alla scheda vendita
 * @param docId
 * @param userId
 * @private
 */
export async function handleDownloadDoc(docId: string, userId: number): Promise<void> {
    const docUrl = $(`[data-id="${docId}"]`).data("url") as string; // Recupera l'URL del documento

    try {
        await SaveDownloadDoc(docId, userId);
        window.open(docUrl, "_blank");
    } catch (error) {
        console.error("Errore durante il download del documento:", error);
        UI.confirmOneButton("", "Errore durante il download del documento"); //TODO: i18n
    }
}

/**
 *
 * @param docId
 * @param userId
 * @constructor
 * @private
 */
export async function SaveDownloadDoc(docId: string, userId: number): Promise<void> {
    return new Promise((resolve, reject) => {
        $.ajaxWithCredentials({
            url: window.BaseUrlWeb + 'Scheda/AllegatoDownload',
            method: 'GET',
            data: {
                allegatoId: docId,
                userId: userId
            }
        })
            .done(function (data, textStatus, jqXHR) {
                resolve(data);
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus);
                reject({jqXHR, textStatus, errorThrown});
            })
            .always(function () {
                //this.RedirectLogin();
            });
    });
}